export const COMPANY = {
  name: "Maddox Heating and Cooling",
  short: "Maddox",
  phone: "(503) 583-6822",
  phoneHref: "tel:+15035836822",
  email: "Service@maddoxheatingandcooling.com",
  areas: ["Portland, OR", "Vancouver, WA"],
  hours: "Mon–Fri · 9am – 5pm",
  emergency: "24/7 Emergency Repairs",
  logo: "https://customer-assets-jt897jd0.emergentagent.net/job_hvac-repairs-plus/artifacts/5whvucij_logo.jpeg",
};

export const HERO_IMG =
  "https://images.unsplash.com/photo-1660330589827-da8ab7dd3c02?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export const AREA_IMG =
  "https://images.pexels.com/photos/16752907/pexels-photo-16752907.jpeg?auto=compress&cs=tinysrgb&w=2000";

export const SERVICES = [
  {
    id: "01",
    title: "Furnaces",
    tag: "Heating",
    blurb:
      "Gas and electric furnace diagnostics, tune-ups, ignitor and blower repairs. We keep the heat running through Pacific Northwest winters.",
    img: "https://static.prod-images.emergentagent.com/jobs/33c63239-1068-4a79-bd6a-f5e8e9f3f701/images/bdf8d82c9753326da29537fe576423ea1e737226ba4444d7605b11e759e7b225.jpeg",
    span: "md:col-span-7",
  },
  {
    id: "02",
    title: "Air Conditioning",
    tag: "Cooling",
    blurb: "AC service, refrigerant checks, and full performance restoration.",
    img: "https://static.prod-images.emergentagent.com/jobs/33c63239-1068-4a79-bd6a-f5e8e9f3f701/images/537890e369aa1e1d38faf51681cbfe391c83862e635484f6f683d39529b6a7b8.jpeg",
    span: "md:col-span-5",
  },
  {
    id: "03",
    title: "Heat Pumps",
    tag: "Dual-Season",
    blurb: "Year-round heat pump repair and seasonal servicing for efficiency.",
    img: "https://static.prod-images.emergentagent.com/jobs/33c63239-1068-4a79-bd6a-f5e8e9f3f701/images/a352e413a0887e4e265b48879a4c0635c26f37eec28c0163cd5cf0cfb55949f7.jpeg",
    span: "md:col-span-5",
  },
  {
    id: "04",
    title: "Gas Inserts",
    tag: "Fireplaces",
    blurb:
      "Gas fireplace insert cleaning, safety inspections, pilot, thermocouple and valve repairs. Cozy, safe, and reliable all season long.",
    img: "https://images.pexels.com/photos/14681670/pexels-photo-14681670.jpeg?auto=compress&cs=tinysrgb&w=1400",
    span: "md:col-span-7",
  },
  {
    id: "05",
    title: "Maintenance",
    tag: "Prevention",
    blurb:
      "Scheduled tune-ups that catch small issues before they become breakdowns.",
    img: "https://images.pexels.com/photos/5463581/pexels-photo-5463581.jpeg?auto=compress&cs=tinysrgb&w=1400",
    span: "md:col-span-6",
  },
  {
    id: "06",
    title: "Repairs",
    tag: "Rapid Response",
    blurb:
      "Fast, honest diagnostics and repairs on any make or model. No installs — just expert fixes.",
    img: "https://static.prod-images.emergentagent.com/jobs/33c63239-1068-4a79-bd6a-f5e8e9f3f701/images/b8bad76151e9ad29e7b49858b333da470dcea6995e53824627d0f55d057934cc.jpeg",
    span: "md:col-span-6",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Service, not sales.",
    body: "We don't push installs. We diagnose, repair, and maintain the equipment you already own — honestly and thoroughly.",
  },
  {
    n: "02",
    title: "Built for the Northwest.",
    body: "From Portland winters to Vancouver summers, our technicians know exactly what your system fights against.",
  },
  {
    n: "03",
    title: "Upfront every time.",
    body: "Clear pricing before we start. No surprises, no jargon, no upsell you didn't ask for.",
  },
  {
    n: "04",
    title: "Same-day when it matters.",
    body: "No heat? No cool? We prioritize emergencies so your home never stays uncomfortable for long.",
  },
];

export const STATS = [
  { value: "15+", label: "Years in the trade" },
  { value: "2", label: "Metro areas served" },
  { value: "24/7", label: "Emergency response" },
  { value: "100%", label: "Repair-focused" },
];

export const SERVICE_OPTIONS = [
  "Furnace",
  "Air Conditioning",
  "Heat Pump",
  "Fireplace",
  "Maintenance / Tune-up",
  "Emergency Repair",
  "Not sure",
];
